import { useTheme } from 'foundations-theming/utils';

/**
 * Wraps the content in a view with a max inline size of 1280px and a margin of auto.
 * This allows all of our content to be equally centered.
 *
 * @param children - The children to wrap.
 * @returns The wrapped content.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const ContentWrapper = ({
  children,
  isHubless = false
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsx("div", {
    style: {
      boxSizing: 'content-box',
      maxInlineSize: '1280px',
      marginInline: 'auto',
      paddingInline: isHubless ? theme.space['400'] : '0'
    },
    children: children
  });
};